module.exports = __webpack_public_path__ + "static/media/Immenzza.c368c377.png";